import { getAssetUrl } from '../constants/storage';

// Types d'applications disponibles
export type AppType = 'Finance' | 'Shopping' | 'Transport' | 'Logement' | 'Service' | 'Social' | 'Autres';

// Définition du type pour les applications business avec les propriétés supplémentaires
export type BusinessAppWithIcon = {
  id: number;
  name: string;
  name_en?: string | null;
  logo: string;
  banner: string;
  description: string;
  description_en?: string | null;
  show: boolean;
  is_business_app?: boolean;
  view?: 'main' | 'other';
  type?: AppType;
  created_at?: string;
  updated_at?: string;
};

// Fallback data pour les applications business au cas où la requête échoue
export const FALLBACK_BUSINESS_APPS: BusinessAppWithIcon[] = [
  {
    id: 19,
    name: 'Kalpé Business',
    name_en: 'Business Wallet',
    logo: getAssetUrl('myfiles/logos/Kalpe%20Business2.png'),
    banner: getAssetUrl('Files/Banners/ca207a8e-fa8a-4de0-9b47-0a3a1030a1a8.jpeg'),
    description: 'Votre portefeuille pour gérer les transactions et paiements de votre entreprise en toute simplicité.',
    description_en: 'Your wallet to manage your business transactions and payments with ease.',
    show: true,
    view: 'main',
    type: 'Finance',
  },
  {
    id: 20,
    name: 'Point de vente',
    name_en: 'Point of Sale',
    logo: getAssetUrl('Files/Logos/Point%20de%20Vente%20Logo.png'),
    banner: getAssetUrl('myfiles/logos/4bd578138076a423b352f3a2e8b1f345.jpg'),
    description: 'Point de vente et terminal de paiement Burok.',
    description_en: 'Burok point of sale and payment terminal for your business.',
    show: true,
    view: 'main',
    type: 'Finance',
  },
  {
    id: 21,
    name: 'Ma Kiosk',
    name_en: 'My Kiosk',
    logo: getAssetUrl('myfiles/logos/Makiosk.gif'),
    banner: getAssetUrl('Files/Banners/Kiosk%20!!.png'),
    description: 'Créez votre boutique en ligne et gagnez de l\'argent dans Burok',
    description_en: 'Create your online store and start earning money on Burok.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 22,
    name: 'My Events',
    name_en: 'My Events',
    logo: getAssetUrl('Files/Logos/Events.gif'),
    banner: getAssetUrl('Files/Banners/Events.jpg'),
    description: 'Découvrez et participez aux meilleurs événements.',
    description_en: 'Discover and organize the best events for your audience.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 23,
    name: 'Ma Boutique',
    name_en: 'My Shop',
    logo: getAssetUrl('Files/Logos/RestaurantsAppLogo.png'),
    banner: getAssetUrl('myfiles/PublicImages/Temi%20Coker%20-%20Visual%20Artist%20based%20in%20Dallas,%20Texas%20in%20Dallas,%20TX,%20USA.jpeg'),
    description: 'Commandez auprès des commerces à proximité et faites-vous livrer.',
    description_en: 'Receive orders from nearby customers and deliver with ease.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 24,
    name: 'Mon Restaurant',
    name_en: 'My Restaurant',
    logo: getAssetUrl('myfiles/logos/MaRestau.gif'),
    banner: getAssetUrl('Files/Banners/Hamburger.jpeg'),
    description: 'Commandez vos plats préférés et faites-vous livrer à domicile.',
    description_en: 'Manage your restaurant orders and deliver meals to your customers.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 25,
    name: 'Burok Talli',
    name_en: 'Burok Talli',
    logo: getAssetUrl('Files/Logos/TalliLogo.gif'),
    banner: getAssetUrl('Files/Banners/BUROKTALLINEWBANNER.png'),
    description: 'Devenez livreur Burok et livrez dans toute la ville.',
    description_en: 'Become a Burok driver and deliver across the city.',
    show: true,
    view: 'main',
    type: 'Transport',
  },
  {
    id: 26,
    name: 'My Link',
    name_en: 'My Link',
    logo: getAssetUrl('Files/Logos/MyLink.gif'),
    banner: getAssetUrl('Files/Banners/cbc91ee86e94b375a360d36101ade469.jpg'),
    description: 'Connectez-vous avec votre communauté et partagez vos moments.',
    description_en: 'Connect with your community and grow your audience on My Link.',
    show: true,
    view: 'main',
    type: 'Social',
  },
  {
    id: 27,
    name: 'Mes services',
    name_en: 'My Services',
    logo: getAssetUrl('Files/Logos/Mes%20Services.gif'),
    banner: getAssetUrl('Files/Banners/Colorsss.jpeg'),
    description: 'Accédez à tous vos services essentiels en un seul endroit.',
    description_en: 'Access all your essential business services in one place.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 28,
    name: 'Recruter',
    name_en: 'Recruit',
    logo: getAssetUrl('myfiles/PublicImages/BurokJoblogo.png'),
    banner: getAssetUrl('Files/Banners/2d2d4bce-ba1f-407c-b9eb-fecfb9f4e153.jpeg'),
    description: 'Trouvez les meilleures opportunités professionnelles.',
    description_en: 'Find the best professional opportunities and recruit the right people.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 29,
    name: 'Roots.',
    name_en: 'Roots.',
    logo: getAssetUrl('Files/Logos/Roots..gif'),
    banner: getAssetUrl('Files/Banners/RootsPresent.png'),
    description: 'Accédez aux dernières actualités, articles et tendances médiatiques en un seul endroit.',
    description_en: 'Access the latest news, articles, and media trends all in one place.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 30,
    name: 'Placemento',
    name_en: 'Placemento',
    logo: getAssetUrl('myfiles/logos/PlacementoV2.gif'),
    banner: getAssetUrl('myfiles/PublicImages/Placemento%20BurokPresent.png'),
    description: 'Boostez votre visibilité avec des campagnes publicitaires et du marketing d\'influence dans l\'application Burok',
    description_en: 'Boost your visibility with ad campaigns and influencer marketing inside the Burok app.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 31,
    name: 'Colis GP',
    name_en: 'GP Parcels',
    logo: getAssetUrl('Files/Logos/ColisApplogo.png'),
    banner: getAssetUrl('Files/Banners/ColiPresentation.jpeg'),
    description: 'Tu cherches un livreur ou GP ? Pas de probleme. Expédiez, suivez et recevez vos colis en toute simplicité.',
    description_en: 'Looking for a delivery driver or GP? No problem. Send, track, and receive your parcels with ease.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 32,
    name: 'Keurgui',
    name_en: 'Keurgui',
    logo: getAssetUrl('Files/Logos/KeurguiAppLogo.png'),
    banner: getAssetUrl('Files/Banners/Keurgui.jpeg'),
    description: 'Trouvez une maison, un appartement, un hôtel… tout est dans Keurgui !',
    description_en: 'Find a house, apartment, hotel… everything is in Keurgui!',
    show: false,
    view: 'other',
    type: 'Logement',
  },
  {
    id: 34,
    name: 'Point de Retrait',
    name_en: 'Cash-out Point',
    logo: getAssetUrl('Files/Logos/PDRETRAITAPP.png'),
    banner: getAssetUrl('myfiles/logos/PORBanner.jpeg'),
    description: 'Devenez partenaire de retrait et gagnez des commissions sur chaque retrait d\'argent.',
    description_en: 'Become a withdrawal partner and earn commissions on every cash-out.',
    show: true,
    view: 'other',
    type: 'Finance',
  },
  {
    id: 37,
    name: 'ShopLink',
    name_en: 'ShopLink',
    logo: getAssetUrl('Files/Logos/LogoAppShoplink.png'),
    banner: getAssetUrl('Files/PublicImages/SHOPLINK%20Banner.gif'),
    description: 'Connectez vos boutiques Burok avec vos reseaux sociaux',
    description_en: 'Send money in one tap, even internationally, with your Paylink.',
    show: false,
    view: 'other',
    type: 'Shopping',
  },
  {
    id: 39, 
    name: 'Propulse',
    name_en: 'Propulse',
    logo: getAssetUrl('myfiles/logos/Propulse.png'),
    banner: getAssetUrl('myfiles/Videos/PropulseAppBanner.mp4'),
    description: 'Financez et lancez votre projet e-commerce avec le Financement Burok Propulse',
    description_en: 'Finance and launch your e-commerce project with Burok Propulse funding.',
    show: false,
    view: 'other',
    type: 'Finance',
  },
  {
    id: 40,
    name: 'PayLink Business',
    name_en: 'PayLink Business',
    logo: getAssetUrl('myfiles/logos/PaylinkBusiness2.png'),
    banner: getAssetUrl('Files/PublicImages/PAYLINK%20Banner.png'),
    description: 'Acceptez les paiements en ligne avec PayLink Business. Gérez votre portail et vos moyens de paiement.',
    description_en: 'Accept online payments with PayLink Business. Manage your portal and payment methods.',
    show: true,
    view: 'other',
    type: 'Finance',
  },
];